<template>
  <el-button
    :size="size"
    :type="type"
    :disabled="disabled"
    v-bind="$attrs"
    :loading="loadingStatus"
    @click="handleClick"
  >
    <slot/>
  </el-button>
</template>
<script>
export default {
  name: 'loading-button',
  props: {
    autoLoading: {
      type: Boolean,
      default: true
    },
    label: {
      type: String
    },
    size: {
      type: String
    },
    type: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loadingStatus: false
    }
  },
  methods: {
    handleClick () {
      if (this.autoLoading) {
        this.loadingStatus = true
      }
      this.$emit('click', () => {
        this.loadingStatus = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Buttons/loading-button.vue